
import { textStyles, colors, fonts } from '../../shared/styles';

export const styles = {
  contentCard: {
    minHeight: 300,
    padding: '17px 25px 40px',
    backgroundColor: colors.white,
    boxShadow: colors.cardShadow,
  },
  contentCardMobile: {
    minHeight: 300,
    padding: '17px 15px 40px',
    backgroundColor: colors.white,
    boxShadow: colors.cardShadow,
  },
  loaderContainer: {
    padding: '100px 25px 40px',
    backgroundColor: colors.white,
  },
  filterCol: {
    paddingRight: 50,
  },
  title: {
    ...textStyles.head1Grey,
    marginBottom: 20,
    marginTop: 0,
    fontWeight: 'normal',
  },
  raceTitle: (isMobile) => ({
    fontSize: (isMobile) ? 14 : 21,
    color: colors.textColor,
  }),

  detailRow: {
  	...textStyles.body1Grey,
  },
  noListMessage: {
    marginBottom: 20,
    paddingTop: 40,
    ...textStyles.body1Grey,
  },

  addYourselfContainer: {
    marginTop: 20,
    padding: '20px 0',
    backgroundColor: colors.lightGrey,
    alignItems: 'center',
  },
  photoContainer: {
    display: 'inline-block',
  },
  addYourselfTitle: {
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: 26
  },
  addYourselfButtons: {
    paddingTop: 5,
    textAlign: 'right',
  },

  titleContainer: {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '60%',
    minWidth: 250,
    marginBottom: 20,
    ...textStyles.head1Grey,
  },
  startListTitleContainer: {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '60%',
    minWidth: 250,
    marginBottom: 48,
    marginTop: 0,
    fontWeight: 'normal'
  },
  titleSearch: (isMobile) => ({
    display: 'inline-block',
    verticalAlign: 'top',
    width: isMobile ? '90%' : '40%',
    margin: isMobile ? '20px' : null,
    minWidth: 250,
    marginBottom: 24,
    textAlign: 'right',
  }),

  addButton: {
    width: 182,
    height: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 2,
    color: colors.white,
    textTransform: 'capitalize',
    fontSize: 15,
    border: 'none',
    backgroundColor: colors.blue,
  },
  buttonStyle: {
    border: `1px solid ${colors.blue}`,
    borderRadius: 3,
    letterSpacing: 0,
    textTransform: 'capitalize',
    color: colors.white,
    cursor: 'pointer',
    transition: 'all 0.3s',
    display: 'flex',
    fontSize: 18,
    padding: '3px 5px',
    margin: 3,
    minWidth: 12,
    width: 182,
    height: 45,
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'ProximaNovaRegular'
  },
  coursePattern: {
    textAlign: 'center',
    fontFamily: 'ProximaNovaSemiBold'
  },
  areYouInThisRace: (isMobile) => ({
    ...styles.addYourselfTitle,
    paddingLeft: isMobile ? 25 : '',
    textAlign: isMobile ? 'center' : ''
  }),
  startListFilterContainer: (isMobile) => ({
    paddingBottom: (isMobile) ? '' : 36
  }),
  noFollowersInfo: {
    fontSize: 18,
    fontFamily: 'ProximaNovaRegular',
    padding: 50
  },
  editButton: {
    display: 'inline-block',
    backgroundColor: colors.blue,
    padding: '8px 17px 7px',
    borderRadius: 2,
    cursor: 'pointer'
  },
  submitButtonStyle: (isHover, additionalStyling, isDark) => (
    {
      ...fonts.heavy,
      ...styles.buttonStyle,
      ...additionalStyling,
      backgroundColor: isDark ? (isHover) ? colors.darkBlue : colors.blue
                              : (isHover) ? additionalStyling.hoverBackgroundColor || 'rgba(22, 169, 225, 0.05)': colors.white,
      color: isDark ? colors.white : ((isHover) ? additionalStyling.hoverColor : additionalStyling.color) || colors.blue,
      height: 'inherit',
      width: additionalStyling.width || 250
    }
  ),
  submitButtonContainer: (isMobile) => isMobile ?
    ({
    }) :
    ({
      display: 'flex',
      justifyContent: 'center'
    }),
  submitButtonRacing: (isHover, additionalStyling) => ({
    width: 140,
    border: '2px solid '+ (isHover ? colors.darkBlue : colors.blue),
    backgroundColor: (isHover) ? colors.blue : colors.white,
    color: (isHover) ? colors.white : colors.blue,
    ...additionalStyling
  }),
  noResultsYetContainer: (isMobile) => ({
    color: colors.textColor,
    marginBottom: isMobile ? 30 : ''
  }),
  raceNotStartedTitle: (isMobile) => ({
    fontSize: isMobile ? 22 : 30
  }),
  raceNotStartedSubTitle: {
    color: colors.grey,
    fontSize: 16
  },
  startTime : {
    container: {
      textAlign: 'center',
      width: 85
    },
    time: {
      borderBottom: `1px solid ${colors.lightGrey2}`,
      textTransform: 'uppercase',
      fontFamily: 'ProximaNovaSemibold',
      fontSize: 12,
      paddingBottom: 5
    },
    timeMsg: {
      fontFamily: 'BebasNeueBold',
      fontSize: 28,
      paddingTop: 3
    }
  },
  starters: {
    container: {
      display: 'flex',
      justifyContent: 'center',
      padding: '10px 16px 10px 0px'
    },
    athletePhoto: (index) => ({
      marginRight: -16,
      backgroundColor: colors.white,
      borderRadius: '50%',
      padding: 3,
      zIndex: index
    }),
    remaining: {
      marginLeft: 20,
      color: colors.blue,
      display: 'flex',
      alignItems: 'center'
    }
  },
  notInStartListContainer: {
      marginTop: 20,
      alignItems: 'center',
      backgroundColor: colors.lightGrey5,
      padding: '20px 0'
  },
  notInStartListPhotoContainer: {
      display: 'flex',
      alignItems: 'center'
  },
  scheduleFootnote: (isMobile) => ({
      textTransform: 'uppercase',
      marginTop: 15,
      marginBottom: isMobile ? 25 : 0,
      fontSize: isMobile ? 14 : 16
  }),
  pagerContainer: {
   display: 'flex',
   justifyContent: 'center',
   paddingTop: 20
  },
};



/** WEBPACK FOOTER **
 ** ./views/eventStartList/styles.js
 **/